module.exports = __webpack_public_path__ + "Server-Unhealthy.TentacleActive.f473525c9942c566bf2c9406b5b0a0a3.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unhealthy.TentacleActive.png
// module id = 1264
// module chunks = 1